import { EditDashboardEmoji } from '@modules/dashboard/components/EditDashboardDetailsDialogContent/EditDashboardEmoji';
import { DASHBOARD_NAME_MAX_LENGTH } from '@modules/dashboard/constants';
import { Stack, TextField, Typography } from '@mui/material';

interface DashboardNameAndEmojiInputProps {
  emoji: string;
  onEmojiChange: (emoji: string) => void;
  dialogRef: HTMLDivElement | null;
  name: string;
  onNameChange: (name: string) => void;
}

export const DashboardNameAndEmojiInput = ({
  emoji,
  onEmojiChange,
  dialogRef,
  name,
  onNameChange,
}: DashboardNameAndEmojiInputProps) => {
  const isCharacterLimitExceeded = name.length > DASHBOARD_NAME_MAX_LENGTH;

  return (
    <Stack spacing={1} direction="row" width="100%">
      <EditDashboardEmoji
        dashboardEmoji={emoji}
        setDashboardEmoji={onEmojiChange}
        dialogRef={dialogRef}
      />
      <Stack alignItems="flex-end" spacing={0.5} width="100%">
        <TextField
          error={isCharacterLimitExceeded}
          required
          fullWidth
          autoFocus
          label="Dashboard Name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
        />
        <Typography
          variant="caption"
          color={isCharacterLimitExceeded ? 'error' : 'text.secondary'}
        >
          {name.length}/{DASHBOARD_NAME_MAX_LENGTH}
        </Typography>
      </Stack>
    </Stack>
  );
};
